export default __webpack_public_path__ + "bbc9caa962f14ccef7217cfc696f4b79.svg";